(function() {
  
  angular
    .module('meanApp')
    .controller('PersonaController', personaController);

    personaController.$inject = ['$scope'];

  	function personaController($scope) {
	    this.index = Math.floor(Math.random() * 4) + 0  ;
	    this.personasInfos = [{
	    	text : 'Marie est soucieuse de sa santé et de son bien être. Elle souhaite perdre quelques kilos sans perdre de temps à cuisiner.',
	    	tags : [{value: 'fast'}, {value : 'lowcalory'}],
	    	avatarClass : 'marieavatar',
	    	name : 'Marie'
	    }, {
	    	text : 'Nathan est étudiant et souhaite manger pour peu cher. Mais il ne possède ni four ni micro ondes.',
	    	tags : [{value: 'fast'}, {value : 'nooven'}, {value : 'nomicrowave'}],
	    	avatarClass : 'nathanavatar',
	    	name : 'Nathan'
	    }, {
	    	text : "Ce soir c'est vendredi et il fait très chaud. Clara invite ses collègues à prendre l'apéro. Un des convives ne mange pas de porc.",
	    	tags : [{value: 'aperitif'}, {value : 'cold'}, {value : 'nopig'}],
	    	avatarClass : 'fatihaavatar',
	    	name : 'Clara'
	    }, {
	    	text : "Lito fréquente les salles de sport régulièrement. Son objectif est d'avoir un corps musclé. Il compose des menus protéinés pour accompagner sa métamorphose.",
	    	tags : [{value: 'protein'}/*, {value : 'lowcalory'}*/],
	    	avatarClass : 'litoavatar',
	    	name : 'Lito'
	    }, {
	    	text : "Fatiha, jeune grand mère végétarienne accueille ses petits enfants pour le week end. Le plus jeune est allergique au gluten. Elle cherche une recette de crêpes sans gluten.",
	    	tags : [{value: 'vegetarian'}, {value : 'nogluten'}, {value : 'dessert'}],
	    	avatarClass : 'claraavatar',
	    	name : 'Fatiha'
	    }];

	    this.persona = this.personasInfos[this.index || 0];

	    /**this.init = function () {
	    	this.index = 0;
	    	console.log('will init the value');	
	    };**/

	    this.onClick = function () {
	    	if (this.index === 4) {
	    		this.index = 0;
	    	}
	    	else {
	    		this.index = this.index +1;
	    		//$scope.index = this.index;
	    	}
	    	this.persona = this.personasInfos[this.index || 0];
	    };
	    

	    //function to increase the  index
	}

})();